import { useMemo } from "react";

import type {
    LeadsColumnOptionsByLeadsType,
    LeadsSearchColumnListConfig,
    LeadsType,
} from "app/pages/sales-intelligence/modules/leads-search";
import type { IColumnSelectionResult } from "app/pages/sales-intelligence/modules/leads-search/types/columns";
import { computeColumnSelectionOptions } from "app/pages/sales-intelligence/modules/leads-search/utils/columns";
import { useColumnsConfigOptionsQuery } from "app/pages/sales-intelligence/modules/lists/query/queries/useColumnsConfigOptionsQuery";

import useLeadsSearchResult from "../query/queries/useLeadsSearchResult";

const DEFAULT_OPTIONS: LeadsColumnOptionsByLeadsType = {
    categories: [],
    available: { websites: [], companies: [] },
};

export const useListsColumnSelectionOptions = (
    columnConfig: LeadsSearchColumnListConfig,
    activeSearchLeadsType: LeadsType,
): IColumnSelectionResult => {
    const { data: config = DEFAULT_OPTIONS } = useColumnsConfigOptionsQuery(columnConfig);
    const { data: selected } = useLeadsSearchResult(activeSearchLeadsType);

    return useMemo(
        () => computeColumnSelectionOptions(config, selected, columnConfig, activeSearchLeadsType),
        [config, selected, columnConfig, activeSearchLeadsType],
    );
};
